/**
 * Utility functions for mapping fallacy properties to UI badge variants.
 * These pure functions ensure consistent visual representation across the app.
 */

export const getSeverityVariant = (severity: string): "severity-high" | "severity-medium" | "severity-low" => {
  if (severity === "High") return "severity-high";
  if (severity === "Medium") return "severity-medium";
  return "severity-low";
};

export const getImpactVariant = (severity: string): "impact-high" | "impact-medium" | "impact-low" => {
  if (severity.includes("High")) return "impact-high";
  if (severity.includes("Medium")) return "impact-medium";
  return "impact-low";
};

export const getCategoryVariant = (category: string): "category-formal" | "category-informal" | "category-appeal" | "category-causation" | "category-ambiguity" => {
  if (category === "Formal") return "category-formal";
  if (category === "Informal") return "category-informal";
  if (category === "Appeal") return "category-appeal";
  if (category === "Causation") return "category-causation";
  return "category-ambiguity";
};
